import {jsonMember, jsonObject} from "typedjson";
import {DxBaseControlOptions} from "./dx-base-control-options";

@jsonObject
export class DxTextareaControlOptions extends DxBaseControlOptions{

  /**
   * Возможные опции для textarea
   *  @controlId: string - ID контрола
   *  @label: string - подпись
   *  @hint: string - всплывающая подсказка
   *  @isDisabled: boolean - поле активно/не активно
   *  @isHidden: boolean - поле спрятано/отображается
   *
   *  @placeholder: string - заполнитель
   *  @isFocused: boolean - фокус на поле ввода
   *  @cols: number - количество колонок в поле ввода
   *  @rows: number - количество строк в поле ввода
   * */


  /** заполнитель */
  @jsonMember({name: "placeholder", constructor: String, emitDefaultValue: false, isRequired: false})
  private _placeholder: string;

  /** фокус на поле ввода */
  @jsonMember({name: "isFocused", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isFocused: boolean;

  /** Количество колонок в поле ввода */
  @jsonMember({name: "cols", constructor: Number, emitDefaultValue: false, isRequired: false})
  private _cols: number;

  /** Количество строк в поле ввода */
  @jsonMember({name: "rows", constructor: Number, emitDefaultValue: false, isRequired: false})
  private _rows: number;


  get placeholder(): string {
    return this._placeholder;
  }

  set placeholder(value: string) {
    this._placeholder = value;
  }

  get isFocused(): boolean {
    return this._isFocused;
  }

  set isFocused(value: boolean) {
    this._isFocused = value;
  }

  get rows(): number {
    return this._rows;
  }

  set rows(value: number) {
    this._rows = value;
  }

  get cols(): number {
    return this._cols;
  }

  set cols(value: number) {
    this._cols = value;
  }
}

